import { combineReducers } from "redux";
import convertorCompressor from "./convertorCompressor";

export default combineReducers ({
    convertorCompressor
});